import { createContext, useContext } from "react";

const OffersRefreshContext = createContext(null);

export const OffersRefreshProvider = OffersRefreshContext.Provider;

export const useOffersRefresh = () => {
    return useContext(OffersRefreshContext);
};
